import { observer } from "mobx-react";
import * as React from "react";
import { MDBCol, MDBRow } from "mdbreact";

@observer
export class ResponseRestorePage extends React.Component<{}, {}> {

  constructor(props: any) {
    super(props);
  }

  render() {

    return (
      <>
        <div className="container-fluid container-login">
          <MDBRow>
            <MDBCol md="6" className="form-login" style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>

              <div className="login-img">
                <img src="/images/logo-novo.png" className="img-responsive" />
              </div>

              <br />

              <h6 className="title-login" style={{ textAlign: "center", marginBottom: 20 }}>Obrigado. acabamos de enviar um email para você. <br /> Nele, haverá um link, acesse-o para recuperar sua senha.</h6>

              <div style={{ textAlign: "center", fontSize: 15, marginTop: "auto", marginBottom: 20 }}>
                <div className="name-ent">Gerenciador Fiscal e Tributário Ltda.</div>
                <div>© 2023 . Todos os Direitos Reservados.</div>
              </div>

            </MDBCol>

            <MDBCol md="6" className="fundo-login">
              <div className="fundo-bg"></div>
            </MDBCol>

          </MDBRow>

        </div>
      </>
    );
  }
}

export default ResponseRestorePage;
